import { isEmpty } from 'lodash'

import constants from 'constants/index'

const { ENABLE_DAI_DISPUTE_ANALYSIS_TAG } = constants.governanceProjectSettings

const disputeAnalysisEnabled = (activity) => {
  const settings = activity?.governanceProject?.governanceProjectSettings

  if (isEmpty(settings)) return false

  const setting = settings.find(
    (currentSetting) => currentSetting?.tag === ENABLE_DAI_DISPUTE_ANALYSIS_TAG,
  )

  return setting?.value === true
}

export default disputeAnalysisEnabled
